import { Divider, TextField, Typography } from '@mui/material';
import { FC } from 'react';

import { AnnotationType } from 'src/types/apiContract';

import { getAnnotationTextValueByType } from './helpers';
import { MappedAnnotations } from './types';

type Props = {
  annotations: MappedAnnotations;
  onChange: (annotationType: AnnotationType, value: string) => void;
};

type AnnotationTextProps = {
  value?: string | null;
  onChange: (annotationType: AnnotationType, value: string) => void;
  type: AnnotationType;
}

const AnnotationText: FC<AnnotationTextProps> = ({ value, onChange, type }) => (
  <TextField
    onChange={(event) => onChange(type, event.target.value)}
    variant="outlined"
    value={value}
    placeholder="Ex: 12345678"
  />
);

const Package: FC<Props> = ({ annotations, onChange }) => (
  <>
    <Typography variant="subtitle2">Invoice Number</Typography>
    <AnnotationText
      onChange={onChange}
      type={AnnotationType.PurchaseInvoiceNumber}
      value={getAnnotationTextValueByType(annotations, AnnotationType.PurchaseInvoiceNumber)}
    />
    <Divider sx={{ borderStyle: 'dashed', width: '100%' }} />
    <Typography variant="subtitle2">PO Number</Typography>
    <AnnotationText
      onChange={onChange}
      type={AnnotationType.PurchaseOrderNumber}
      value={getAnnotationTextValueByType(annotations, AnnotationType.PurchaseOrderNumber)}
    />
    <Divider sx={{ borderStyle: 'dashed', width: '100%' }} />
    <Typography variant="subtitle2">Reference Numbers</Typography>
    <AnnotationText
      onChange={onChange}
      type={AnnotationType.Reference1Number}
      value={getAnnotationTextValueByType(annotations, AnnotationType.Reference1Number)}
    />
    <AnnotationText
      onChange={onChange}
      type={AnnotationType.Reference2Number}
      value={getAnnotationTextValueByType(annotations, AnnotationType.Reference2Number)}
    />
    <AnnotationText
      onChange={onChange}
      type={AnnotationType.Reference3Number}
      value={getAnnotationTextValueByType(annotations, AnnotationType.Reference3Number)}
    />
  </>
);
export default Package;
